// services/everpro/everpro-order/query.ts â€” AWB lookup per-brand via S2 proxy.
// Label PDF + tracking status dipisah di ./track.js

import { everproFetch } from '../everpro-auth';


export async function getEverproAwb(clientOrderNo: string, brandId: string): Promise<string> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  // AWB butuh waktu propagate setelah generate â€” retry 4x jeda 2s saat 404/empty.
  let lastMessage = 'AWB number belum tersedia. Coba beberapa saat lagi.';
  for (let attempt = 0; attempt < 4; attempt++) {
    if (attempt > 0) await new Promise(r => setTimeout(r, 2000));

    const res = await everproFetch(brandId, `/shipment/v1/orders/${encodeURIComponent(clientOrderNo)}/awb`, {
      method: 'GET',
    });

    if (res.ok) {
      try {
        const json = await res.json();
        const awb = json?.data?.awb_number;
        if (awb) return awb;
      } catch { /* parse ulang */ }
      lastMessage = 'AWB number belum tersedia. Coba beberapa saat lagi.';
      continue;
    }

    const detail = await res.text().catch(() => '');
    let message = '';
    try { message = JSON.parse(detail).message || ''; } catch { /* */ }
    lastMessage = message || `Everpro get AWB: ${res.status} ${res.statusText}`;
    if (res.status !== 404) throw new Error(lastMessage);
  }

  throw new Error(lastMessage);
}



// Probe AWB SEKALI (tanpa retry). Dipakai booking: AWB umumnya SUDAH terbit saat
// create (auto-generate) → cukup 1 GET, hindari panggilan /generate yang selalu
// 400 "order already has AWB Number" (spam 400 tiap booking, insiden 2026-10-06).
export async function getEverproAwbOnce(clientOrderNo: string, brandId: string): Promise<string> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  const res = await everproFetch(brandId, `/shipment/v1/orders/${encodeURIComponent(clientOrderNo)}/awb`, {
    method: 'GET',
  });
  if (!res.ok) return '';
  try {
    const json = await res.json();
    return json?.data?.awb_number || '';
  } catch {
    return '';
  }
}


export async function findEverproOrderByClientNo(
  clientOrderNo: string,
  brandId: string,
): Promise<{ awbNumber: string; status: string; statusId: number; shipmentOrderNo: string; courierDetail: string } | null> {
  if (!brandId) throw new Error('Everpro: brandId wajib');

  const res = await everproFetch(brandId, `/shipment/v1/orders?search=${encodeURIComponent(clientOrderNo)}`, {
    method: 'GET',
  });
  if (!res.ok) return null;

  const json = await res.json();
  const orders = json?.data?.orders ?? [];
  const found = orders.find((o: any) => o.shipment_order_no === clientOrderNo || o.client_order_no === clientOrderNo);
  if (!found) return null;

  return {
    awbNumber: found.awb_number || '',
    status: found.status || '',
    statusId: found.status_id ?? 0,
    shipmentOrderNo: found.shipment_order_no || '',
    courierDetail: found.courier_detail || '',
  };
}
